const Object = {

    // FIELDS
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "equipment": "Equipment",
    "name": "Name",
    "object_number": "Object Number",
    "description": "Description",
    "new_part_number": "New Part Number",
    "old_part_number": "Old Part Number",
    "km_item_code": "KM Item Code",
    "object_type": "Object Type",
    "object_template": "Object Template",
    "object_condition": "Object Condition",
    "quantity": "Quantity",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "object": "Object",

    // ERROR
    "error_department": "Select Department",
    "error_location": "Select Location",
    "error_component": "Select Component",
    "error_equipment": "Select Equipment",
    "error_name": "Enter Name",
    "error_object_number": "Enter Object Number",
    "error_part_number": "Enter Part Number",
    "error_object_type": "Enter Object Type",
    "error_object_template": "Select Object Template",
    "error_object_condition": "Select Object Condition",
    "error_quantity": "Enter Quantity",
    "error_quantity_min": "Quantity cannot be less than 1",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_department": "DEPARTMENT",
    "table_location": "LOCATION",
    "table_component": "COMPONENT",
    "table_equipment": "EQUIPMENT",
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_name": "NAME",
    "table_object_number": "OBJECT NUMBER",
    "table_quantity": "QTY",
    "table_status": "STATUS",

}

export default Object;